var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"mainDiv"},[_c('div',{staticClass:"login flex"},[_c('presentation'),_c('div',{staticClass:"right-portion"},[_c('login-signup')],1)],1),_c('div',{staticClass:"logo"},[_c('Companies')],1)]),_c('div',{staticClass:"mobile-view"},[_c('login-mobile')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }